export default "__VITE_ASSET__DZr9DkN1__"